import { v4 as uuidv4 } from "uuid";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import {
  S3Client,
  PutObjectCommand,
  DeleteObjectCommand,
} from "@aws-sdk/client-s3";

const {
  VITE_VIEW_S3_URL,
  VITE_POOL_ID,
  VITE_AWS_S3_BUCKET_NAME,
  VITE_AWS_S3_REGION,
} = import.meta.env;

const region = VITE_AWS_S3_REGION as string;
const IdentityPoolId = VITE_POOL_ID as string;
const s3BucketName = VITE_AWS_S3_BUCKET_NAME as string;

const cognitoClient = new CognitoIdentityClient({ region });

const s3Client = new S3Client({
  region,
  credentials: fromCognitoIdentityPool({
    client: cognitoClient,
    identityPoolId: IdentityPoolId,
  }),
});

export const UploadCognitoImage = async (file: File) => {
  try {
    const isAllowedImageType =
      file?.type === "image/png" ||
      file?.type === "image/jpeg" ||
      file?.type === "image/jpg" ||
      file?.type === "image/gif" ||
      file?.type === "image/webp" ||
      file?.type === "image/svg+xml";

    if (!isAllowedImageType) {
      throw new Error(
        "Unsupported file type. Only PNG, JPG/JPEG, and GIF are allowed."
      );
    }

    // Generate a unique file name using UUID
    const fileName = `${uuidv4()}-${file?.name}`;

    
    const uploadParams = {
      Bucket: s3BucketName,
      Key: `images/${fileName}`,
      ContentType: file.type,
      Body: file, // pass the ReadableStream
    };

    // Create and send the upload command to S3
    const command = new PutObjectCommand(uploadParams);
    const data = await s3Client.send(command);

    console.log({ data });

    return {
      success: true,
      data: fileName,
      location: `${fileName}`,
    };
  } catch (error: any) {
    console.error({ error });
    return { success: false, message: error?.message };
  }
};

export const deleteCognitoImage = async (fileName: string) => {
  try {
    const deleteParams = {
      Bucket: s3BucketName,
      Key: `images/${fileName}`,
    };

    const command = new DeleteObjectCommand(deleteParams);

    const data = await s3Client.send(command);
    console.log(`Deleted image: ${data}`);

    return {
      success: true,
      message: `File ${fileName} deleted successfully.`,
    };
  } catch (error: any) {
    console.log({ error });
    return { success: false, message: error?.message };
  }
};
